export const FETCH_GOLD_WITHDRAWALS_START = "FETCH_GOLD_WITHDRAWALS_START";
export const FETCH_GOLD_WITHDRAWALS_SUCCESS = "FETCH_GOLD_WITHDRAWALS_SUCCESS";
export const FETCH_GOLD_WITHDRAWALS_ERROR = "FETCH_GOLD_WITHDRAWALS_ERROR";